import { inject, Pipe, PipeTransform } from '@angular/core';
import { UserService } from '../services/user.service';

@Pipe({
  name: 'username',
})
export class UserNamePipe implements PipeTransform {
  private readonly userService = inject(UserService);

  async transform(userId: string): Promise<string> {
    const user = await this.userService.getUserById(userId).catch(() => null);

    if (!user) return 'neznámý uživatel';

    return user.user.human.profile.displayName;
  }
}
